export class box{

    constructor(
    public currency_id?: number,
    public mount?: string
    ){}
  }
